import { Vspace } from '../../components/styled/Separators.style'
import PageContainerCmp from "../PageContainerCmp";
import { LINEAR_BASE_ROUTE, LINEAR_PATHS } from "../../routes/linearRouteConstants";
import { LEndPageTitle, LEndText } from "../../components/styled/Text.style";
import { LEndSection } from "../../components/styled/Containers.style";
import LinearFooterCmp from "../../components/footer/LinearFooter";
import { LIconContainer } from '../../components/styled/Icon.style';
import linearTy from '../../assets/img/linear_thankyou.svg';
import { useAppSelector } from '../../store/hooks';
import { selectCommunicationData } from '../../store';
import { useEffect } from 'react';
import { CommunicationType } from '../../types/communication/communicationDataType';
import { useDispatch } from 'react-redux';
import { saveCommunicationAct } from '../../store/communication-data/actions';

const EndToDriverThankYouPageLinear = () => {
    const dispatch = useDispatch();
    const communicationData = useAppSelector(selectCommunicationData);
    const { communication } = communicationData;
    const { token, forceLastPathname, lastPathname } = communication;

    useEffect(() => {
        
        const urlParams = new URLSearchParams(window?.location?.search || '')
        const isDriverContext = urlParams.get('driver') === 'true'
        let pathnamePage = `/${LINEAR_BASE_ROUTE}/${token}/${LINEAR_PATHS.CAI_PRESENTATION_PAGE}?driver=true`
        if ((forceLastPathname?.includes("?driver=true") || lastPathname?.includes("?driver=true")) && !isDriverContext) {
            return;
        }
        dispatch(saveCommunicationAct({
            data: new CommunicationType({
                ...communication,
                forceLastPathname: pathnamePage,
                lastPathname: pathnamePage
            })
        }))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <>

            <PageContainerCmp
                routePath={LINEAR_PATHS.END_TO_DRIVER_THANK_YOU_PAGE}
                removeNextBtn
                isForceLastPathname={true}
                avoidBackgroundAction={true}
            >
                <LEndSection>

                    <LIconContainer style={{ marginTop: "-220px" }}>
                        <img
                            src={linearTy}
                            alt="Messaggio inviato"
                            style={{ width: "250px" }}
                        />
                    </LIconContainer>

                    <LEndPageTitle >GRAZIE!</LEndPageTitle>
                    <Vspace qty={2}></Vspace>
                    <LEndText>Hai inoltrato la comunicazione al conducente che era alla guida, sarà lui a compilare a proseguire con il processo.</LEndText>

                </LEndSection>

                <LinearFooterCmp inverted={true} />

            </PageContainerCmp>
        </>

    )
}

export default EndToDriverThankYouPageLinear